<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
<div class="wy-customer-overview-panel-customer-location" v-loading="loading" element-loading-text="Loading..." @mouseover="mouseover" @mouseout="mouseout">
    <wy-panel-header ref="panelHeader" :panelHeaderData="pannelData" :controller="module" :panelTitle="panelTitle" />
    <wy-panel-map-chart ref="locationMap" class="pie-left-column-right" />
    
    <div class="table-container" v-if="rawData && rawData.length>0">
        <table class="customer-overview-table">
            <thead>
                <tr class="table-titles">
                    <div class="table-flex-container head-container">
                        <td class="performance-table-head intent-name">Country</td>
                        <td class="performance-table-head volume">Users</td>
                        <td class="performance-table-head total-volume total-valume-header">% Users</td>
                    </div>
                </tr>
            </thead>
            <tbody>
                <el-collapse>
                    <el-collapse-item v-for="(item, index) in rawData" :key="index">
                        <template slot="title">
                                <div class="location-flex-collapse" @click="handleCollapseExpanded">
                                    <td class="intent-name">
                                        <img class="flag-icon" :src="`https://flagcdn.com/${item.countryCode}.svg`" width="20" alt="country flag"/>
                                        {{item.label}}
                                        <span :class="(collapseExpanded? 'location-arrow-up':'location-arrow-down')"></span>
                                    </td>
                
                                    <td class="volume">{{item.users}}</td>
                                    <td class="total-volume">
                                        <div class="flex-stats">
                                            <span class="percentage">{{item.percentage}}%</span> 
                                            <progress :value="item.percentage" max="100" class="title-percentage-bar"></progress>
                                        </div>
                                    </td>
                                </div>
                            
                        </template>
                            
                        <tr class="location-flex-collapse" v-for="(province, index) in item.provinces" :key="index">
                            <td class="intent-name">
                                
                                {{province.name}}
                            </td>
                            <td class="volume">{{province.users}}</td>
                            <td class="total-volume">
                                <div class="flex-stats">
                                    <span class="percentage">{{province.percentage}}%</span> 
                                    <progress :value="item.percentage" max="100" class="percentage-bar"></progress>
                                </div>
                            </td>
                        </tr>

                    </el-collapse-item>
                </el-collapse>
            </tbody>
        </table>
    </div>
    <div v-else class="location-no-data-flex"> 
        <img class="location-no-data-image" src="../../../assets/icons/icon_performance_no_data.svg" alt="no data icon">
        <span class="location-no-data-text">Sorry!</span>
        <span class="location-no-data-text-small">No data available yet.</span>
    </div>
</div>
</template>

<script>
import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';
import WyPanelHeader from '../../panel-views/wy-panel-header.vue';
import WyPanelLocationMapChart from '../../panel-views/panel-charts/wy-panel-map-chart'

  export default Vue.extend({
    name: 'wy-customer-overview-panel-customer-location',
    props: ["controller"],
    components: { 
        'wy-panel-header': WyPanelHeader,
        'wy-panel-map-chart': WyPanelLocationMapChart,
    },

    data() {
      return {
        module: this,
        loading: false,
        templateData: {},
        rawData: {},
        pannelData: {},
        sectionData: {},
        lineChartData: {},
        panelId: 'customerlocation',
        collapseExpanded: false,
        panelTitle: 'Customer Location',
        legendData: {},
        dataIndex: 0,
        dateRange: 'month',

        mapData: null
      }
    },

    computed: {
      ...mapGetters(['dataModel', 'companyConfig']),
    },

    methods: {
      ...mapActions(['fetchCustomerLocationData', 'prepareCustomerBehaviourViewByData']),

      async changeDateRange(dateRange) {
        this.dateRange = dateRange;
        this.controller.changeDateRange(dateRange, this.rawData, this.templateData, this);
      },
      handleCollapseExpanded(){
        this.collapseExpanded = !this.collapseExpanded;
      },
      mouseover() {
        this.$refs.panelHeader.$refs.settingSection.$el.classList.add("show");
      },
      mouseout() {
        // if(e.toElement._prevClass == "components-container") {
        //   this.$refs.panelHeader.$refs.settingSection.$refs.configureDropdown.hide();
        // }
        this.$refs.panelHeader.$refs.settingSection.$el.classList.remove("show");
      },
      
      showDropdowns(){
        setTimeout(() => {
          document.querySelectorAll('.el-select-dropdown__wrap').forEach(el => {
          el.style.display = "block";
          })
        }, 100);
      },

      async handleFilterChange() {
        if(!this.loading) {
          this.loading = true;
          //this.rawData = await this.fetchCustomerLocationData(this.controller.selection);
          this.rawData = [
                {
                    label: 'Canada',
                    countryCode: 'ca',
                    users: 10000,
                    percentage: 97,
                    provinces:[
                    {
                        name: "British Columbia",
                        users: 10000,
                        percentage: 97
                    },
                    {
                        name: "British Columbia",
                        users: 10000,
                        percentage: 97
                    },
                    {
                        name: "British Columbia",
                        users: 10000,
                        percentage: 97
                    },
                    ]
                },
                {
                    label: 'USA',
                    countryCode: 'us',
                    users: 10000,
                    percentage: 97,
                    provinces:[
                    {
                        name: "British Columbia",
                        users: 10000,
                        percentage: 97
                    },
                    {
                        name: "British Columbia",
                        users: 10000,
                        percentage: 97
                    },
                    {
                        name: "British Columbia",
                        users: 10000,
                        percentage: 97
                    },
                    ]
                },
                {
                    label: 'UK',
                    countryCode: 'gb',
                    users: 10000,
                    percentage: 97,
                    provinces:[
                    {
                        name: "British Columbia",
                        users: 10000,
                        percentage: 97
                    },
                    {
                        name: "British Columbia",
                        users: 10000,
                        percentage: 97
                    },
                    {
                        name: "British Columbia",
                        users: 10000,
                        percentage: 97
                    },
                    ]
                },
                {
                    label: 'Canada',
                    countryCode: 'ca',
                    users: 10000,
                    percentage: 97,
                    provinces:[
                    {
                        name: "British Columbia",
                        users: 10000,
                        percentage: 97
                    },
                    {
                        name: "British Columbia",
                        users: 10000,
                        percentage: 97
                    },
                    {
                        name: "British Columbia",
                        users: 10000,
                        percentage: 97
                    },
                    ]
                },
                {
                    label: 'Canada',
                    countryCode: 'ca',
                    users: 10000,
                    percentage: 97,
                    provinces:[
                    {
                        name: "British Columbia",
                        users: 10000,
                        percentage: 97
                    },
                    {
                        name: "British Columbia",
                        users: 10000,
                        percentage: 97
                    },
                    {
                        name: "British Columbia",
                        users: 10000,
                        percentage: 97
                    },
                    ]
                },
            ]
          if(this.rawData && this.$refs.locationMap) {
            if(this.$el.querySelector(".el-loading-mask")) {
                this.$el.querySelector(".el-loading-mask").style.display = 'none'
            }
            this.loading = false;

            this.mapData = {
                locations: this.rawData.map(el => el.label),
                labels: this.rawData.map(el => el.label),
                values: this.rawData.map(el => el.users)
            }
            this.$refs.locationMap.buildChart(this.mapData);
          }
           else {
            this.loading = false;
          }
        }
      },
    },

    async created(){
      await this.handleFilterChange();
    }
  });
</script>

<style lang="scss">
.location-no-data-flex{
    display: flex;
    min-height: 183px;
    height: 184px;
    flex-direction: column;
    align-items: flex-start;
}
img.flag-icon {
    border-radius: 3px;
    width: 19px;
}
.location-no-data-image{
    margin-top: 2% !important;
    margin-left: 46.5%;
    width: 11%;
}
.panel-top-title{
    font-family: Helvetica Neue, Arial, Helvetica, sans-serif;
    padding: 15px 15px 0 15px;
    font-size: 14.5px;
    font-weight: medium;
    color: var(--site-font-secondary-color);
}
.location-no-data-text{
    font-family: Helvetica Neue, Arial, Helvetica, sans-serif;
    font-size: 0.7vw;
    color: var(--site-font-tertiary-color);
    font-weight: 500;
    margin-left: 0.9vw;
    width: 100%;
    text-align: center;
    margin-top: 0.46vw;
}
.location-no-data-text-small{
    font-family: Helvetica Neue, Arial, Helvetica, sans-serif;
    font-size: 13.5px;
    color: var(--site-font-tertiary-color);
    margin-top: 0.5vw;
    margin-left: 0.9vw;
    margin-bottom: 3.27vw;
    width: 100%;
    text-align: center;
}
.wy-customer-overview-panel-customer-location {
    @media screen and (min-width: 2000px){
        .arrow-down {
            display: none !important;
        }
    }
    @media screen and (max-width: 1888px){
        td.performance-table-head.volume {
            margin-right: 1.5vw;
        }
    }
    @media screen and (min-width: 1888px){
        td.performance-table-head.volume {
            margin-right: 1vw;
        }
    }
    .wy-customer-overview-table-with-dropdowns .table-titles th {
    left: -57px !important;
    }

    table.customer-overview-table {
        width: 100%;
        overflow: hidden;
        border-top: 1px #CAD2DA solid;

    }
    .pie-left-column-right {
        padding-right: 0px;
        margin-bottom: 0px !important;
        width: 100% !important;
        height: 380px !important;
        overflow: hidden;
        border-radius: 0px !important;
        border-bottom: none !important;
        /* height: 160px !important; */
        margin-top: 0px !important;
        // border-bottom: 0px !important;
        margin-right: 0px !important;
        border-left: none !important;
    }
    .el-button{
        border-radius: 5px;
        font-size: 16px;
        border: none !important;
        color: var(--site-font-secondary-color);
        font-weight: 400 !important;
        padding: 12px 30px 12px 0px!important;
    }
    .location-module-button{
        width: 182px;
        text-align: left;
        max-width: 182px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .location-dropdown-flex{
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .setting-icon {
        padding: 0px 3px 8px 7px;
        position: relative;
        top: 2px;
    }
    .setting-img{
        user-select: none !important;
        width: 18px;
        top: 0.217vw;
    }
    .bottom-flex-dropdown{
        display: flex;
        justify-content: flex-end;
    }
    .setting-arrow-down{
        position: relative;
        top: 2px;
    }
    .el-collapse {
        border-top: none !important;
        border-bottom: none !important;
    }
    .el-button.is-plain:hover, .el-button.is-plain:active {
        background: #FFF;
        border: none !important; 
        color: var(--site-font-tertiary-color);
    }
    .table-container .el-icon-arrow-down:before {
        content: "\E6DF";
        color: #828E9A;
        font-size: 10px;
    }
    .location-arrow-up{
        background-image: url("../../../assets/icons/icon_location_module_arrowup.svg");
        background-size: 100%;
        background-position-x: 0px;
        background-position-y: 2px;
        margin-left: 10px;
        background-repeat: no-repeat;
        height: 8px;
        width: 8px;
        display: inline-block
    }
    .el-collapse-item__content{
        padding: 0 !important;
    }
    .location-arrow-down{
        background-image: url("../../../assets/icons/icon_location_module_arrowdown.svg");
        background-size: 100%;
        background-position-x: 0px;
        background-position-y: 2px;
        margin-left: 10px;
        background-repeat: no-repeat;
        height: 8px;
        width: 8px;
        display: inline-block
    }
    

    .table-container {
        .table-flex-container {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
        .performance-table-head{
            font-family: Helvetica Neue, Arial, Helvetica, sans-serif !important;
            font-size: 14.5px !important;
            font-weight: 700 !important;
            color: var(--site-font-secondary-color) !important;
        }
        .head-container{
            border-bottom: 1px solid #CAD2DA;
            white-space: nowrap;
            padding-top: 4px;
            padding-bottom: 10px;
        }
        .total-valume-header {
            margin-right: 10px;
        }
        .percentage{
            position: relative;
            left: 0.5vw;
        }

        .el-icon--right {
            float: right;
        }
        .arrow-down{
            width: 7px;
        }
        .el-icon-arrow-down:before {
            content: "\E6DF";
            color: #828E9A;
        }
        thead {
            display: table;
            width: calc(102% - 0px);
            color: #000000;
            position: relative;
            right: 6px;
            font-size: 14.5px;
            font-family: Helvetica Neue, Helvetica;
            font-weight: 500;
        }
        tbody {
            display: inline-block; /* to enable vertical scrolling */
            max-height: 174px;
            overflow-y: scroll; /* keeps the scrollbar even if it doesn't need it; display purpose */
            width: calc(100% - 4px);
            padding-left: 1px;
            background-color: #FFF;
        }
        tbody::-webkit-scrollbar {
            border-radius: 10px;
            width: 6px;
        }
        tbody::-webkit-scrollbar-thumb {
            background: #CAD2DA;
            border-radius: 10px;
            
        }
        tbody::-webkit-scrollbar-track {
            background: transparent;
            border-radius: 10px;
           
        }
        .location-flex-collapse{
            display: flex;
            width: 100%;
            justify-content: space-between;
            height: 65px;
        }
        .el-collapse-item__arrow {
            display: none;
        }
        .el-collapse-item__header {
            align-items: center !important;
            height: 55px !important;
            border: 0px !important;
        }
        progress {
            display: block;
            width: 100%;
            padding: 0px 0 0 0;
            margin: 0;
            background: none;
            border: 0;
            border-radius:5 0px;
            text-align: left;
            position: relative;
            font-family: "Helvetica Neue", Helvetica;
            font-size: 15px;
            overflow: hidden;
        }
        progress.percentage-bar::-webkit-progress-value {
            background: #4B67A3 !important;
            overflow: hidden;
        }
        progress::-webkit-progress-bar {
            height: 10px;
            width: 65%;
            margin: 0 auto;
            background-color: #CAD2DA;
            border-radius: 100px; 
            position: relative;
            top:2px;
            overflow: hidden;
        }
        progress::-webkit-progress-value {
            display: inline-block;
            height: 10px;
            bottom: 6px;
            position: relative;
            margin: 0px -10px 2px 0;
            // padding-left: 50px; /* Rounded corners requires a padding */
            border-radius: 50px 0 0 50px;
        }

        progress.title-percentage-bar::-webkit-progress-value {
            background: #4B67A3  !important;
            overflow: hidden;
        }
        progress.title-percentage-bar::-webkit-progress-bar {
            height: 10px;
            width: 65%;
            margin: 0 auto;
            background-color: #CAD2DA;
            border-radius: 100px; 
            position: relative;
            top:2px;
            overflow: hidden;
        }
        progress.title-percentage-bar::-webkit-progress-value {
            display: inline-block;
            height: 10px;
            bottom: 16px;
            position: relative;
            margin: 0px -10px 2px 0;
            // padding-left: 50px; /* Rounded corners requires a padding */
            border-radius: 50px 0 0 50px;
        }
        

        .intent-name{
            padding-right: 37px;
            font-family: Helvetica Neue, arial;
            color: var(--site-font-tertiary-color);
            font-size: 14.22px;
        }
        td.performance-table-head.intent-name {
            margin-left: 31px;
        }
        td.performance-table-head.total-volume.total-valume-header {
            margin-right: 1vw;
        }
        .index{
            width: 0vw;
            left: 22px;
            padding-right: 0vw;
            position: relative;
            font-family: Helvetica Neue, arial;
            color: var(--site-font-tertiary-color);
            font-size: 14.22px;
            padding-left: 0vw;
        }
        .volume{
            width: 4.24vw;
            position: relative;
            font-family: Helvetica Neue, arial;
            color: var(--site-font-tertiary-color);
            font-size: 14.22px;
            right: 5.97vw;
            text-align: center;
        }
        th.index{
            display: none;
        }
        th.volume{
            display: inline-block;
            white-space: nowrap;
            font-family: Helvetica Neue, arial;
            color: var(--site-font-tertiary-color);
            text-align: start;

        }
        th.intent-name {
            // margin-left: 28px;
            display: inline-block;
            text-align: start;
            white-space: nowrap;
            width: 6.07vw !important;
            max-width: 6.13vw;
            overflow: hidden;
        }
        th.total-volume{
            display: inline-block;
            white-space: nowrap;
            text-align: start;
            width: 6.07vw 

        }
        .total-volume{
            width: 1.82vw;
            position: relative;
            right: 10.23vw;
            padding-right: 0vw;
            font-family: Helvetica Neue, arial;
            color: var(--site-font-tertiary-color);
            font-size: 14.22px;
        }
        .flex-stats{
            display: flex;
            justify-content: space-around; 
            align-items: center;
            width: 11.7vw !important;
        }
        .performance-overview-table{
            width: 100%;
            height: 100%;
            border-collapse: collapse;
            font-size: 14.22px;
        }
        td{
            padding: 6px 15px;
        }
        th{
            padding: 16.5px 25px;
        }
        .table-titles th{
            // border-bottom: 1px solid #e3e8ec;
            position: -webkit-sticky;
            position: sticky;
            top: 0;
            background: white;
            z-index: 1500;
        }
        .table-titles{
            .total-volume{
            position: relative !important;
            right: 10vw;
            }
        }

        tr {
            display: table; /* display purpose; th's border */
            width: 100%;
            box-sizing: border-box; /* because of the border (Chrome needs this line, but not FF) */
        }

        td {
            text-align: left;
            color: #000000 !important;
            border-bottom: none;
            border-left: none;
            // width: 19px !important;
            font-size: 14.22px;
            font-family: Helvetica Neue, Helvetica;
            font-weight: 400;
        }
        .warning-row{
            color:black;
        }
        td.intent-name {
            width: 162px !important;
            max-width: 162px;
            display: inline-block;
            white-space: nowrap;
            overflow: hidden;
            position: relative;
        }
        .change-overtime-info{
            display: flex;
            flex-direction: column;
            margin-left: 0.3vw;
        }
        .top-flex{
            background-color: #FFF;
        }
        .el-table .cell {
            font-size: 14.22px;
            color: var(--site-font-chart-color);
            font-weight: normal;
            position: relative;
            left: 0.35vw;
        }

        .icon-info{
            display: inline-block;
            background: url('../../../assets/icons/icon_info_performance_overview.svg') no-repeat;
            width: 20px;
            height: 17px;
            position: relative;
            top: 8px;
            margin-left: 0.25vw;
        }
        #line-chart{
            position: relative;
            right: 1vw;
            width: 22.59vw;
            bottom: 2vw;
        }
        .move-info{
            width: 0.9vw;
            height: 19px;
            margin-left: 5px;
            position: relative;
            top: 4px;
        }

        .el-loading-mask {
            height: 686px !important;
        }
    }
}
</style>